export default "__VITE_ASSET__DZp49JMn__"